import script from "./HowToPay.vue?vue&type=script&setup=true&lang=ts"
export * from "./HowToPay.vue?vue&type=script&setup=true&lang=ts"

import "./HowToPay.vue?vue&type=style&index=0&id=2528b3c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2528b3c7"]])

export default __exports__